import { render, staticRenderFns } from "./TeamsSkeleton.vue?vue&type=template&id=66ebfb66&scoped=true&"
import script from "./TeamsSkeleton.vue?vue&type=script&lang=js&"
export * from "./TeamsSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ebfb66",
  null
  
)

export default component.exports